import { ScheduleApi } from 'api/ScheduleApi';
import { backendApiClient } from 'container/backendApiClient';

export const scheduleApi = new ScheduleApi(backendApiClient);
